export enum MainPage {
  PLAN = "plan",
  CATALOG = "catalog",
  CURRICULUM = "curriculum",
}
